import { render } from "./Interno.vue?vue&type=template&id=539d549e&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./Interno.vue?vue&type=script&lang=js"
export * from "./Interno.vue?vue&type=script&lang=js"

import "./Interno.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script